import { Injectable } from '@angular/core';

import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

import { CacheService, ITypeProcessBO, ITypeValorationProcessBO } from '@mapfre-tech/amap3';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import moment from 'moment';


type MemoryCacheEntry = { data: ITypeProcessBO[] | null; lastReqDate: moment.Moment | null; _subject?: Subject<ITypeProcessBO[]>; observer?: Observable<ITypeProcessBO[]> };

@Injectable({
  providedIn: 'root'
})
export class ProcessTypeService {

  className = 'ProcessTypeService';

  memoryCache: Record<string, MemoryCacheEntry> = {
    "processTypes": { data: null, lastReqDate: null },
    "processTypesValoration": { data: null, lastReqDate: null }
  }

  constructor(private http: HttpClient, private cacheService: CacheService) {
  }

  getAllProcessTypes(cache = true, cacheKey = "processTypes"): Observable<ITypeProcessBO[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<ITypeProcessBO[]>;
    } else {
      const observable = this.http.get<ITypeProcessBO[]>(environment.base_URL + "/types-processes").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  getAllProcessTypesValoration(cache = true, cacheKey = "processTypesValoration"): Observable<ITypeValorationProcessBO[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<ITypeValorationProcessBO[]>;
    } else {
      const observable = this.http.get<ITypeValorationProcessBO[]>(environment.base_URL + "/types-valoration-process").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newProcessType(newProcessType: ITypeProcessBO) {
    return this.http.post(environment.base_URL + "/types-processes", newProcessType);
  }

  updateProcessType(editedProcessType: ITypeProcessBO) {
    return this.http.put(environment.base_URL + `/types-processes/${editedProcessType.idTypeProcessPk}`, editedProcessType)
  }

  deleteProcessType(id: number) {
    return this.http.delete(environment.base_URL + `/types-processes/${id}`)
  }

  canUseCache(key: string) {
    const oldDate = this.memoryCache[key]?.lastReqDate;
    return oldDate != null && moment().diff(oldDate, 'minutes') <= 1;
  }

  updateCacheData(data: ITypeProcessBO[], key: string) {
    this.memoryCache[key].data = data;
    this.memoryCache[key]._subject?.next(data);
  }

  updateCacheReq(key: string) {
    const _subject = new Subject<ITypeProcessBO[]>();
    const observer = _subject.asObservable();
    this.memoryCache[key] = { data: null, lastReqDate: moment(), _subject, observer };
  }
}
